import { PhoneNumber } from '@dreryk/phone-number-common-api';

import { InteractiveTable, InteractiveTableCellProps } from '@dreryk/react-components';
import { useTranslate } from '@dreryk/react-common';

import { translationKeys } from '../../../../../translations';

type EmergencyNotificationSmsConfigurationContactPersonPhoneNumberCellProps = InteractiveTableCellProps<PhoneNumber | null>;

export const EmergencyNotificationSmsConfigurationContactPersonPhoneNumberCell = (
   props: EmergencyNotificationSmsConfigurationContactPersonPhoneNumberCellProps
): JSX.Element => {
   const translate = useTranslate();
   return (
      <InteractiveTable.PhoneNumberInputCell
         index={props.index}
         name={props.name}
         testId={props.testId}
         placeholder={translate(translationKeys.fillPhoneNumber)}
         defaultValue={props.defaultValue}
         validationRules={{
            required: true,
         }}
         prefixDisabled
      />
   );
};
